import React from "react";
import axios from "axios";
import { base_url } from "./Components/Constant";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Route, Routes } from "react-router";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Home from "./Components/Views/Home";
import Contact from "./Components/Views/Contact";
import NavBar from "./Components/NavBar";
import FreeNapkin from "./Components/Views/FreeNapkin";
import ZeroWastageFood from "./Components/Views/ZeroWastageFood";
import TestimonialsDetails from "./Components/Views/Testimonials";
import Team from "./Components/Views/Team";
import BinaPayasarBazar from "./Components/Views/BinaPayasarBazar";
import Darpan from "./Components/Views/Darpan";
import DarpanView from "./Components/Views/DarpanView";
import MediaCoverage from "./Components/Views/MediaCoverage";
import MediaCoverageView from "./Components/Views/MediaCoverageView";
import RecentActivity from "./Components/Views/RecentActivity";
import Education from "./Components/Views/Education";
import MedicalHelp from "./Components/Views/MedicalHelp";
import DirectBloodDonate from "./Components/Views/DirectBloodDonate";
import Covid from "./Components/Views/Covid";
import NatureBachao from "./Components/Views/NatureBachao";
import KhushiFerao from "./Components/Views/KhushiFerao";
import DBDFrom from "./Components/Views/DirectBloodDonate/DBDFrom";
import MemberJoiningForm from "./Components/Views/Member/MemberJoiningForm";
import DonateUs from "./Components/Views/Donate/DonateUs";
import VerifyMember from "./Components/Views/VerifyMember/VerifyMember";

const root = ReactDOM.createRoot(document.getElementById("root"));
// Log visitor info only once per session
if (!sessionStorage.getItem("visitLogged")) {
  axios.post(`${base_url}/visitor-info`, {})
    .catch((err) => { /* Optionally handle error */ });
  sessionStorage.setItem("visitLogged", "true");
}
root.render(
  <React.StrictMode>
    {/* <BrowserRouter basename="/react-app"> */}
    <BrowserRouter basename="/">
      <Header />
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/testimonials" element={<TestimonialsDetails />} />
        <Route path="/team" element={<Team />} />
        <Route path="/free-napkin" element={<FreeNapkin />} />
        <Route path="/zero-wastage-food" element={<ZeroWastageFood />} />
        <Route path="/bina-paysar-bazar" element={<BinaPayasarBazar />} />
        <Route path="/khushi-ferao" element={<KhushiFerao />} />
        <Route path="/darpan" element={<Darpan />} />
        <Route path="/darpan-view/:id" element={<DarpanView />} />
        <Route path="/media-coverage" element={<MediaCoverage />} />
        <Route
          path="/media-coverage-view/:pdfName"
          element={<MediaCoverageView />}
        />
        <Route path="/recent-activity" element={<RecentActivity />} />
        <Route path="/education-help" element={<Education />} />
        <Route path="/medical-help" element={<MedicalHelp />} />
        <Route path="/dbd" element={<DirectBloodDonate />} />
        <Route path="/apply-dbd" element={<DBDFrom />} />
        <Route path="/apply-member" element={<MemberJoiningForm />} />
        <Route path="/verify-member/:id" element={<VerifyMember />} />
        <Route path="/donate-us" element={<DonateUs />} />
        <Route path="/nature-bachao" element={<NatureBachao />} />
        <Route path="/covid-service" element={<Covid />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
